import { ReactNode, useEffect } from 'react'
import { Provider } from 'react-redux'
import { useGetSessionQuery } from '../services/api/authApi'
import { store } from '../store'
import { clearAuthData, setAuthData, setError, setLoading } from '../store/authSlice'

interface AuthProviderProps {
  children: ReactNode
}

const AuthStateManager = ({ children }: { children: ReactNode }) => {
  const { data, isLoading, error, isError } = useGetSessionQuery()

  useEffect(() => {
    if (isLoading) {
      store.dispatch(setLoading())
    } else if (isError || error) {
      store.dispatch(clearAuthData())
      if (error) {
        store.dispatch(setError(error instanceof Error ? error.message : 'Authentication failed'))
      }
    } else if (data?.session && data.session.user) {
      store.dispatch(
        setAuthData({
          user: data.session.user,
          session: data.session,
        }),
      )
    } else {
      // No session data means user is not authenticated
      store.dispatch(clearAuthData())
    }
  }, [data, isLoading, error, isError])

  return <>{children}</>
}

const AuthProvider = ({ children }: AuthProviderProps) => {
  return (
    <Provider store={store}>
      <AuthStateManager>{children}</AuthStateManager>
    </Provider>
  )
}

export default AuthProvider
